<template>
  <div id="login">
    <!-- <img src="../assets/login/login_bg_img_right@2x.png" class="bg-right" /> -->
    <!-- <img src="../assets/login/login_bg_img_lift@2x.png" class="bg-lift" /> -->
    <!-- <div class="title">中网生态监测大数据平台</div> -->
    <!-- <div class="title">生态监测大数据平台</div> -->
    <!-- <img src="../assets/login/login_bg_img_center@2x.png" class="earth" /> -->
    <div class="left">
      <h1>
        生态监测大数据平台
      </h1>
      <p>
        致力于自然资源调查、生态监测、生态保护与修复、智能物联网硬件的研发、生产、销售和高端大数据平台服务
      </p>
    </div>
    <div class="right">
      <div class="title">
        生态监测大数据平台
      </div>
      <div class="log">
        欢迎登录
      </div>
      <div class="login-container">
        <el-form
          ref="form"
          :model="form"
          label-width="0"
          :rules="rules"
          v-loading="loading"
          class="login-form"
        >
          <el-form-item prop="username">
            <el-input
              placeholder="用户名"
              v-model="form.username"
              @keyup.enter.native="onSubmit('form')"
            >
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="密码"
              v-model="form.password"
              show-password
              @keyup.enter.native="onSubmit('form')"
            >
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="remember">记住密码</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button
              class="login-btn"
              type="primary"
              @click="onSubmit('form')"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from "@/common/http";
import apis from "@/common/api";
import { setCookie } from "@/common/utils";
import qs from "qs";
import jwtDecode from "jwt-decode";
import moment from "moment";

export default {
  name: "App",
  data() {
    return {
      loading: false,
      form: {
        client_id: "webClient",
        grant_type: "password",
        username: "",
        password: "",
        client_secret: "MainsiteSecret",
      },
      remember: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "submit" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "submit" },
        ],
      },
    };
  },
  created() {
    //如果本地储存了账号密码信息，那就回显在输入框
    let username = localStorage.getItem("username");
    let password = localStorage.getItem("password");
    if (username && password) {
      this.form.username = localStorage.getItem("username");
      this.form.password = localStorage.getItem("password");
      this.remember = true; //这一步是回显后让勾选框为选中状态
    }
  },
  components: {},
  mounted() {
    this.enterEvent();
    // if (window.location.href.indexOf("?") > -1) {
    //   let obj = this.parseQueryString(window.location.href);
    //   if (obj.username == "ftkj" && obj.password == "123456") {
    //     console.log("ok");
    //     this.form.username = "ftkj";
    //     this.form.password = "123456";
    //     this.onSubmit("form");
    //   }
    //   if (obj.username == "XAXQ0001" && obj.password == "XAXQ0001") {
    //     console.log("ok");
    //     this.form.username = "XAXQ0001";
    //     this.form.password = "XAXQ0001";
    //     this.onSubmit("form");
    //   }
    // }
  },
  methods: {
    rememberInfo() {
      // 判断用户是否勾选记住密码，如果勾选，在本地储存中储存登录信息
      if (this.remember) {
        localStorage.setItem("username", this.form.username);
        localStorage.setItem("password", this.form.password);
      }
    },
    parseQueryString(url) {
      var result = {};
      if (url.indexOf("?") > -1) {
        var str = url.split("?")[1];
        var temp = str.split("&");
        for (var i = 0; i < temp.length; i++) {
          var temp2 = temp[i].split("=");
          result[temp2[0]] = temp2[1];
        }
      }
      return result;
    },
    enterEvent() {
      document.onkeydown = (e) => {
        if (e.keyCode == "13") {
          this.onSubmit("form");
        }
      };
    },
    // 点击登录
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          http({
            method: "post",
            url: apis.login.api,
            data: qs.stringify(this.form),
            headers: {
              "content-type": "application/x-www-form-urlencoded",
            },
            nocheck: true,
          })
            .then((res) => {
              this.loading = false;
              this.userIdentity = res;
              let d = new Date();
              d.setTime(d.getTime() + 0.5 * 24 * 60 * 60 * 1000);
              let expries = d.toUTCString();
              for (let item in res) {
                if (item === "access_token") {
                  let code = jwtDecode(res[item]);
                  expries = moment(code.exp * 1000).format();
                }
                document.cookie = `${item}=${res[item]};`; // 加入过期时间
                setCookie(item, res[item], expries);
              }
              setCookie("username", this.form.username, expries);
              this.rememberInfo();
              sessionStorage.clear();
              location.href = "./main.html"; // 跳转至登录后页面
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error || "登录失败，请重试",
                type: "error",
              });
              console.log("error", error);
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#login {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  // background: linear-gradient(
  //   133deg,
  //   rgba(29, 95, 218, 1) 0%,
  //   rgba(15, 48, 186, 1) 100%
  // );
  background: url(../assets/login/backgroundLogin2.png) no-repeat center center;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  min-width: 1200px;
  min-height: 1200px;
  overflow: hidden;
  // padding: 0 20px 0 114px;
  box-sizing: border-box;
  position: relative;
  .bg-right {
    position: absolute;
    top: 0;
    right: 0;
    width: auto;
    height: 100%;
    z-index: 0;
  }
  .bg-lift {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 0;
  }
  .left {
    width: 40%;
    height: auto;
    position: absolute;
    top: 288px;
    left: 80px;
    text-align: left;
    color: #fff;
    h1 {
      font-size: 48px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 46px;
    }
    p {
      font-size: 30px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      line-height: 40px;
    }
  }
  .right {
    position: absolute;
    top: 104px;
    right: 117px;
    width: 510px;
    height: 562px;
    background: url(../assets/login/loginBg.png) no-repeat center center;
    background-size: 100% 100%;
    .title {
      margin-top: 59px;
      font-size: 38px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 46px;
      text-align: left;
      margin-left: 71px;
    }
    .log {
      text-align: left;
      font-size: 24px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 32px;
      margin-left: 71px;
      margin-top: 20px;
    }
    .login-container {
      margin-top: 30px;
      width: 100%;
      .login-form {
        padding: 60px 0 52px;
        text-align: left;
        .el-form-item {
          // width: 300px;
          width: 80%;
          margin: 0 auto;
          &:not(:first-child) {
            margin-top: 24px;
          }
        }
        .login-btn {
          margin-top: 12px;
          font-size: 24px;
          width: 100%;
        }
      }
    }
  }
}
/deep/.el-button--primary {
  background: #00b289 !important;
  border: 1px solid #00b289 !important;
}
/deep/.el-loading-mask {
  background-color: transparent !important;
}
//修改loading加载时的颜色
/deep/.el-loading-spinner .path {
  stroke: #00b481;
}
// @media (max-device-width: 375px) {
//   #login {
//     .title {
//       font-size: 140%;
//     }
//     .right {
//       left: 50%;
//     }
//   }
// }
// @media (max-width: 750px) {
//   #login {
//     .title {
//       font-size: 140%;
//     }
//     .right {
//       left: 50%;
//     }
//     .earth {
//       width: 100%;
//     }
//   }
// }
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #00b289;
}
::v-deep .el-checkbox {
  .el-checkbox__label {
    color: #00b289;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #00b289;
    border-color: #00b289;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner,
  .el-checkbox__inner:hover {
    border-color: #00b289;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner,
  .el-checkbox__inner {
    border-color: #00b289;
  }
}
</style>
